import { AlertState } from './alertTypes';
import { createReducer } from '@reduxjs/toolkit';
import { showAlertAction, hideAlertAction } from './alertActions';

export const initialState: AlertState = {
  titulo: '',
  mensagem: '',
  actions: null,
  show: false
};

const frotaReducer = createReducer(initialState, {
  [showAlertAction.toString()]: (state, action) => {
    if (showAlertAction.match(action)) {
      const alert = action.payload;
      if (!alert.actions) {
        alert.actions = null;
      }
      return { ...state, ...alert };
    }
  },
  [hideAlertAction.toString()]: (state, action) => {
    return { ...state, show: false };
  }
});

export default frotaReducer;
